import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"; 
import { faqStatus } from "services/apis";
import { fetchAllFaq } from "services/apis";


const initialState = {
  faqData: [], 
  status: "idle", 
  loading: false,
  error: null,
};


export const getfaqData = createAsyncThunk(
  "faq/fetchfaqData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchAllFaq(); 
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch faq data");
    }
  }
);

export const toggleFaqStatus = createAsyncThunk(
  "faq/toggleFaqStatus",
  async (faqId, { rejectWithValue, getState }) => {
    const faqData = getState().faqData.faqData;
    const updatedFaqData = faqData.map((faq) =>
      faq.question_id === faqId ? { ...faq, status: !faq.status } : faq
  );

    try {
      await faqStatus({ question_id: faqId });
      return updatedFaqData;
    } catch (error) {
      return rejectWithValue(error.message || "Failed to toggle FAQ status");
    }
  }
);

const faqDataSlice = createSlice({
  name: "faqData",
  initialState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(getfaqData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = "loading";
      })
      .addCase(getfaqData.fulfilled, (state, action) => {
        state.loading = false;
        state.faqData = action.payload; 
        state.status = "succeeded";
      })
      .addCase(getfaqData.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload; 
      })
      .addCase(toggleFaqStatus.fulfilled, (state, action) => {
        state.faqData = action.payload;
      })
      .addCase(toggleFaqStatus.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default faqDataSlice.reducer;